import { Component, Input, Output, EventEmitter } from '@angular/core';

interface UploadResult {
  filename: string;
  api?: string;
  flag?: boolean;
  distance?: number;
  tolerance?: number;
  calculated_bh_x?: number;
  calculated_bh_y?: number;
  reference_bh_x?: number;
  reference_bh_y?: number;
  error?: string;
  debug?: any;
}

@Component({
  selector: 'app-dialog-result',
  standalone: false,
  templateUrl: './dialog-result.html',
  styleUrl: './dialog-result.scss',
})
export class DialogResult {
  @Input() isVisible: boolean = false;
  @Input() results: UploadResult[] = [];
  @Output() close = new EventEmitter<void>();
  @Output() clearAll = new EventEmitter<void>();

  onClose(): void {
    this.close.emit();
  }

  onClearAll(): void {
    this.clearAll.emit();
    this.close.emit();
  }

  getPassedCount(): number {
    return this.results.filter(r => r.flag === false).length;
  }

  getFlaggedCount(): number {
    return this.results.filter(r => r.flag === true).length;
  }

  downloadResults(): void {
    if (this.results.length === 0) {
      return;
    }

    // Create CSV content
    const headers = [
      'Filename',
      'API',
      'Survey BH x',
      'Survey BH y',
      'IHS BH x',
      'IHS BH y',
      'Distance (ft)',
      'Flag',
      'Tolerance',
      'Error'
    ];
    const csvRows = [headers.join(',')];

    this.results.forEach(result => {
      const row = [
        `"${result.filename}"`,
        result.api || '-',
        result.calculated_bh_x !== undefined && result.calculated_bh_x !== null ? result.calculated_bh_x.toFixed(2) : '-',
        result.calculated_bh_y !== undefined && result.calculated_bh_y !== null ? result.calculated_bh_y.toFixed(2) : '-',
        result.reference_bh_x !== undefined && result.reference_bh_x !== null ? result.reference_bh_x.toFixed(2) : '-',
        result.reference_bh_y !== undefined && result.reference_bh_y !== null ? result.reference_bh_y.toFixed(2) : '-',
        result.distance !== undefined && result.distance !== null ? result.distance.toFixed(2) : '-',
        result.flag === true ? 'Yes' : (result.flag === false ? 'No' : '-'),
        result.tolerance !== undefined ? result.tolerance.toString() : '-',
        result.error ? `"${result.error.replace(/"/g, '""')}"` : '-'
      ];
      csvRows.push(row.join(','));
    });

    const csvContent = csvRows.join('\n');
    
    // Create blob and download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
    link.setAttribute('href', url);
    link.setAttribute('download', `validation-results-${timestamp}.csv`);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
